import { EventEmitter } from "eventemitter3";

const emitter = new EventEmitter<EmitterListeners>();

export { emitter };

export type EmitterListeners = "file-shared" | "clear-search";
